import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class DebuggerStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.DebuggerStatement;
    }
    visitNode(sb, node, _options) {
        sb.context.reportUnsupported(node);
    }
}

//# sourceMappingURL=DebuggerStatementCompiler.js.map
